export default "__VITE_ASSET__Brx_S$89__"